import { useShareMedia } from 'src/hooks';
import { useEffect, useState } from 'react';
import { useRef } from 'react';
import { useDataContext } from 'src/contexts';

export const useTagBox = () => {
  const { share } = useShareMedia();
  const playwallId = useDataContext((ctx) => ctx.playwallId);

  const [isCopied, setIsCopied] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const hashTag =
    playwallId === 'PW_0001' ? '#PlayWallAtMyTown' : '#PlayWallAtLRT';

  const handleCopy = async () => {
    navigator.clipboard.writeText(hashTag);
    setIsCopied(true);

    const timeout = setTimeout(() => {
      setIsCopied(false);
    }, 2000);
    return () => clearTimeout(timeout);
  };

  const handleShare = () => share();

  useEffect(() => {
    const handleScroll = () => {
      if (buttonRef.current) {
        const rect = buttonRef.current.getBoundingClientRect();
        const isCurrentlySticky = rect.top < window.innerHeight - rect.height;
        setIsSticky(isCurrentlySticky);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return {
    hashTag,
    handleCopy,
    handleShare,
    isCopied,
    isSticky,
    buttonRef,
  };
};
